"use client";

import * as React from "react";

import { css, cva } from "@/../styled-system/css";

const textarea = cva({
  base: {
    py: "2.5",
    px: "3.5",
    rounded: "lg",
    borderWidth: "1px",
    borderColor: "gray.300",
    width: "100%",
    height: "150px",
    resize: "none",
    _focus: {
      outlineColor: "brandBlue",
    },
    _placeholder: {
      color: "gray.500",
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: "0.5",
    },
  },
});

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & { css?: object }
>(({ css: cssProp = {}, ...props }, ref) => {
  const className = css(textarea.raw(), cssProp);
  return <textarea className={className} ref={ref} {...props} />;
});
Textarea.displayName = "Textarea";

export default Textarea;
